export const teamMembers = [
  {
    id: 1,
    name: "Dr. Chukwuemeka Obi",
    role: "CEO & Founder",
    bio: "Founded CPI Technologies in Lagos in 1996. Now leads global AI strategy from Chicago. Former IBM and Accenture consultant with 28+ years in enterprise technology.",
    avatar: "CO",
    color: "from-orange-400 to-red-500",
    linkedin: "#",
  },
  {
    id: 2,
    name: "Sarah Mitchell",
    role: "Chief AI Officer",
    bio: "Ex-Google AI researcher. Architect of agentic systems and LLM-powered platforms processing billions of data points daily across enterprise clients.",
    avatar: "SM",
    color: "from-emerald-400 to-teal-500",
    linkedin: "#",
  },
  {
    id: 3,
    name: "James Adeyemi",
    role: "VP of AI Solutions",
    bio: "Specialist in generative AI, copilot development, and intelligent automation. Led 50+ enterprise AI deployments across North America and Africa.",
    avatar: "JA",
    color: "from-violet-400 to-indigo-500",
    linkedin: "#",
  },
  {
    id: 4,
    name: "Priya Nair",
    role: "Head of AI Engineering",
    bio: "ML engineer with deep expertise in LangChain, LlamaIndex, and PyTorch. Builds production-ready AI systems for Fortune 500 clients.",
    avatar: "PN",
    color: "from-sky-400 to-cyan-500",
    linkedin: "#",
  },
  {
    id: 5,
    name: "Marcus Webb",
    role: "Lead AI Application Developer",
    bio: "Full-stack AI architect specializing in AI-native SaaS platforms, NLP systems, and computer vision solutions at enterprise scale.",
    avatar: "MW",
    color: "from-rose-400 to-pink-500",
    linkedin: "#",
  },
  {
    id: 6,
    name: "Linda Torres",
    role: "Director of Global Training",
    bio: "Leads CPI Academy globally. Certified AI trainer and i3Cert partner. Delivered AI upskilling programs to 5,000+ professionals across 12 countries.",
    avatar: "LT",
    color: "from-amber-400 to-yellow-500",
    linkedin: "#",
  },
  {
    id: 7,
    name: "Chen Wei",
    role: "AI Research Lead",
    bio: "PhD in Machine Learning from MIT. Published researcher in NLP, agentic systems, and predictive modeling. Drives CPI's AI R&D agenda.",
    avatar: "CW",
    color: "from-fuchsia-400 to-purple-500",
    linkedin: "#",
  },
  {
    id: 8,
    name: "Amara Johnson",
    role: "Cloud & Infrastructure Architect",
    bio: "AWS, Azure & Google Cloud certified. Designs secure, scalable cloud infrastructure for AI workloads across 50+ enterprise clients.",
    avatar: "AJ",
    color: "from-lime-400 to-green-500",
    linkedin: "#",
  },
];

export const serviceDetails = [
  {
    id: 1,
    icon: "ri-brain-line",
    title: "AI Business Consulting",
    tagline: "Strategy before technology, always",
    description: "We don't just implement AI. We align it with your business goals. Our AI consulting practice helps organizations move from AI curiosity to AI-driven competitive advantage through structured strategy, governance, and change management.",
    features: [
      "AI Opportunity Assessment & Roadmap",
      "Use Case Prioritization (ROI-driven)",
      "Data Readiness & Governance",
      "AI Vendor & Tool Selection",
      "Change Management & AI Literacy",
      "Ethical AI Framework Design",
    ],
    color: "from-amber-500 to-orange-500",
    image: "https://readdy.ai/api/search-image?query=AI%20business%20consulting%20strategy%20team%20modern%20boardroom%20Chicago%20enterprise%20professional%20diverse%20executives%20planning%20roadmap%20clean%20minimal%20warm%20neutral%20tones%20wide&width=800&height=500&seq=aisvc1&orientation=landscape",
  },
  {
    id: 2,
    icon: "ri-robot-2-line",
    title: "Agentic AI & Intelligent Automation",
    tagline: "AI that perceives, decides, and acts",
    description: "Move beyond simple automation. We build AI agents that operate autonomously, perceiving their environment, making decisions, and executing complex multi-step workflows without human intervention. From single agents to enterprise-wide multi-agent systems.",
    features: [
      "Autonomous Workflow Agents",
      "Multi-Agent Enterprise Systems",
      "AI-Driven RPA (Robotic Process Automation)",
      "Decision Intelligence Engines",
      "LLM-Based Reasoning Agents",
      "Customer Support & Supply Chain Automation",
    ],
    color: "from-emerald-500 to-teal-500",
    image: "https://readdy.ai/api/search-image?query=agentic%20AI%20automation%20futuristic%20robot%20agents%20workflow%20orchestration%20dark%20professional%20technology%20abstract%20glowing%20nodes%20network%20connections%20cinematic%20wide&width=800&height=500&seq=aisvc2&orientation=landscape",
  },
  {
    id: 3,
    icon: "ri-chat-ai-line",
    title: "AI Chatbots & Virtual Assistants",
    tagline: "Conversational AI that actually works",
    description: "Engage customers and empower employees with intelligent conversational AI. We build custom chatbots and virtual assistants that understand context, learn from interactions, and deliver real value, not just scripted responses.",
    features: [
      "Custom ChatGPT & Copilot-style Assistants",
      "Voice-Enabled AI Agents",
      "Omnichannel Chatbots (Web, WhatsApp, Slack, Teams)",
      "Enterprise Knowledge Bots (HR, IT, FAQs)",
      "Generative AI Search & Q&A over Your Data",
      "Built on OpenAI, Azure AI, Google Vertex AI",
    ],
    color: "from-sky-500 to-cyan-500",
    image: "https://readdy.ai/api/search-image?query=AI%20chatbot%20virtual%20assistant%20interface%20modern%20clean%20professional%20enterprise%20omnichannel%20chat%20platform%20minimal%20light%20background%20wide&width=800&height=500&seq=aisvc3&orientation=landscape",
  },
  {
    id: 4,
    icon: "ri-global-line",
    title: "AI-Powered Websites & Digital Experiences",
    tagline: "Your website should be intelligent",
    description: "We build websites that don't just look great, they think. AI-enhanced corporate sites with personalized content, ecommerce with intelligent recommendations, and dynamic lead generation systems that convert visitors into customers.",
    features: [
      "AI-Enhanced Corporate Websites",
      "Ecommerce with AI Product Recommendations",
      "Visual Search & Dynamic Pricing",
      "AI-Driven Chat-First Navigation",
      "SEO + AI Content Optimization",
      "Headless CMS + AI Integration",
    ],
    color: "from-rose-500 to-pink-500",
    image: "https://readdy.ai/api/search-image?query=AI%20powered%20website%20digital%20experience%20modern%20clean%20interface%20personalization%20ecommerce%20professional%20minimal%20light%20neutral%20background%20wide&width=800&height=500&seq=aisvc4&orientation=landscape",
  },
  {
    id: 5,
    icon: "ri-code-s-slash-line",
    title: "Custom AI Software Development",
    tagline: "Tailored, scalable, production-ready",
    description: "We design and build custom AI applications from the ground up — AI-native SaaS platforms, machine learning models, NLP systems, computer vision solutions, and generative AI apps. Every solution is built for scale, security, and real-world performance.",
    features: [
      "AI-Native SaaS Platforms",
      "Machine Learning Models (Predictive, Classification)",
      "Natural Language Processing (NLP) Systems",
      "Computer Vision Solutions",
      "Generative AI Apps (Text, Image, Code)",
      "Tech Stack: Python, LangChain, LlamaIndex, TensorFlow, PyTorch",
    ],
    color: "from-violet-500 to-indigo-500",
    image: "https://readdy.ai/api/search-image?query=custom%20AI%20software%20development%20team%20coding%20Python%20machine%20learning%20modern%20workspace%20professional%20clean%20minimal%20dark%20background%20tech%20wide&width=800&height=500&seq=aisvc5&orientation=landscape",
  },
  {
    id: 6,
    icon: "ri-graduation-cap-line",
    title: "IT Training & Global Certification",
    tagline: "Build the next generation of AI professionals",
    description: "Through CPI Academy and our exclusive partnership with i3Cert (Global Certification Partner for Sub-Saharan Africa), we deliver globally recognized, vendor-aligned certifications and hands-on training. Instructor-led, self-paced, and corporate bootcamp formats available worldwide.",
    features: [
      "Artificial Intelligence & Machine Learning",
      "Generative AI & Prompt Engineering",
      "Agentic AI & Automation Bootcamps",
      "Cybersecurity (Ethical Hacking, SOC, Compliance)",
      "Cloud Computing: AWS, Azure, GCP Certifications",
      "Data Analytics & Engineering Programs",
      "i3Cert: Exclusive Sub-Saharan Africa Partner",
      "Instructor-led, Self-paced & Corporate Bootcamps",
    ],
    color: "from-amber-500 to-yellow-500",
    image: "https://readdy.ai/api/search-image?query=AI%20training%20certification%20program%20diverse%20professionals%20learning%20technology%20modern%20classroom%20global%20corporate%20upskilling%20i3Cert%20warm%20neutral%20tones%20professional%20wide&width=800&height=500&seq=aisvc6b&orientation=landscape",
  },
];

export const processSteps = [
  { step: "01", title: "Discover", desc: "Align AI opportunities with business value: assess goals, data landscape, and AI readiness." },
  { step: "02", title: "Design", desc: "Architect ethical, scalable AI systems with governance, bias checks, and explainability built in." },
  { step: "03", title: "Develop", desc: "Build with MLOps and agentic patterns: production-ready, tested, and fully transparent." },
  { step: "04", title: "Deploy", desc: "Seamless integration with your existing stack, zero disruption, maximum impact." },
  { step: "05", title: "Optimize", desc: "Continuous learning, monitoring, and improvement. Your AI gets smarter over time." },
  { step: "06", title: "Empower", desc: "Train your teams through CPI Academy & i3Cert certification programs for lasting AI capability." },
];

export const awards = [
  { year: "2024", title: "Top AI Consultancy", org: "Clutch.co" },
  { year: "2023", title: "Best AI Solutions Provider", org: "G2 Reviews" },
  { year: "2023", title: "Chicago Tech 50", org: "Crain's Chicago" },
  { year: "2022", title: "Fastest Growing AI Firm", org: "Inc. 5000" },
];
